export default "__VITE_ASSET__Ch2ubGvq__"